import { call, put, takeLatest } from "redux-saga/effects";
import {
  eNhomDeThiInActionIds,
  INhomDeThiInActionTypes,
} from "../../../action-types/de-thi/de-thi-in/INhomDeThiInActions";
import { IBaseRespone } from "../../../../model/respone/IBaseRespone";
import { rootActions } from "../../../actions/rootActions";
import { nhomDeThiInApi } from "../../../../api/de-thi/de-thi-in/nhomDeThiApi";
import { ISMT_NhomDeThiIn } from "../../../../model/respone/de-thi/ISMT_NhomDeThiIn";
import { ISMT_NhomDeThiIn_Request } from "../../../../model/request/de-thi/de-thi-in/ISMT_NhomDeThiIn_Request";

export function* nhomDeThiInSaga(): any {
  yield takeLatest(eNhomDeThiInActionIds.LOAD_START, loadWorker);
  yield takeLatest(eNhomDeThiInActionIds.DELETE_START, deleteWorker);
  yield takeLatest(eNhomDeThiInActionIds.SAVE_START, saveWorker);
  yield takeLatest(
    eNhomDeThiInActionIds.DELETE_MULTIPLE_START,
    deleteMultipleWorker
  );
}

function* loadWorker(action: INhomDeThiInActionTypes): any {
  const res: IBaseRespone = yield call(
    nhomDeThiInApi.SelectByHeMon,
    action.payload as ISMT_NhomDeThiIn_Request
  );
  if (res.is_success) {
    yield put(rootActions.deThi.deThiIn.nhomDeThiIn.LOAD_SUCCESS(res.data));
  } else {
    yield put(
      rootActions.deThi.deThiIn.nhomDeThiIn.LOAD_ERRR(res.message ?? "Có lỗi")
    );
  }
}

function* saveWorker(action: INhomDeThiInActionTypes): any {
  let res: IBaseRespone;
  const payload = action.payload as ISMT_NhomDeThiIn;
  if (payload.id > 0) {
    res = yield call(nhomDeThiInApi.Update, payload);
  } else {
    res = yield call(nhomDeThiInApi.Insert, payload);
  }
  if (res) {
    if (res.is_success) {
      yield put(rootActions.deThi.deThiIn.nhomDeThiIn.SAVE_SUCCESS(res.data));
    } else {
      yield put(
        rootActions.deThi.deThiIn.nhomDeThiIn.SAVE_ERROR(
          res.message ?? "Có lỗi"
        )
      );
    }
  }
}

function* deleteWorker(action: INhomDeThiInActionTypes): any {
  const res: IBaseRespone = yield call(
    nhomDeThiInApi.Delete,
    action.payload as number
  );
  if (res.is_success) {
    yield put(rootActions.deThi.deThiIn.nhomDeThiIn.DELETE_SUCCESS(res.data));
  } else {
    yield put(
      rootActions.deThi.deThiIn.nhomDeThiIn.DELETE_ERROR(
        res.message ?? "Có lỗi"
      )
    );
  }
}
function* deleteMultipleWorker(action: INhomDeThiInActionTypes): any {
  const res: IBaseRespone = yield call(
    nhomDeThiInApi.DeleteMultiple,
    action.payload as number[]
  );
  if (res.is_success) {
    yield put(
      rootActions.deThi.deThiIn.nhomDeThiIn.DELETE_MULTIPLE_SUCCESS(res.data)
    );
  } else {
    yield put(
      rootActions.deThi.deThiIn.nhomDeThiIn.DELETE_MULTIPLE_ERROR(
        res.message ?? "Có lỗi"
      )
    );
  }
}
